'use client';

import React from 'react';
import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import { useTranslation } from 'react-i18next';
import { MinusOutlined } from '@ant-design/icons';

import isBiggerDate from 'utils/date/isBiggerDate';

import { DATE_DOT_FORMAT_2 } from 'constants/date';

import { DateField, IDateFilterProps } from './DateFilter.types';

import './DateFilter.styles.scss';

const { RangePicker } = DatePicker;

const DateFilter = ({ value, size, onChange, className = '', ...props }: IDateFilterProps) => {
  const { t } = useTranslation();

  const endDate = value.endDate ? dayjs(value.endDate) : null;
  const startDate = value.startDate ? dayjs(value.startDate) : null;

  const disabledDate = current => {
    return isBiggerDate(current, dayjs());
  };

  const onChangeDate = dates => {
    const [startDate, endDate] = dates || [];

    const startDateValue = startDate ? startDate.format('MM/DD/YYYY') : null;
    const endDateValue = endDate ? endDate.format('MM/DD/YYYY') : null;

    onChange([DateField.START_DATE, startDateValue, startDate], [DateField.END_DATE, endDateValue, endDate]);
  };

  return (
    <div className={`np-date-filter ${className}`} {...props}>
      <RangePicker
        size={size || 'large'}
        disabledDate={disabledDate}
        placeholder={[t('common.from'), t('common.to')]}
        format={DATE_DOT_FORMAT_2}
        className="bordered"
        style={{ minWidth: 250 }}
        onChange={onChangeDate}
        value={[startDate, endDate]}
        classNames={{ popup: { root: 'np-date-filter__popup' } }}
        separator={<MinusOutlined className="np-date-filter__separator" />}
      />
    </div>
  );
};

export default DateFilter;
